import React, { memo } from 'react';
// import { Circle } from 'react-google-maps';
import { CircleF } from '@react-google-maps/api';


const DisplayCircle = (props) => {
  const { geoBound } = props;

  return (
    <CircleF
      defaultCenter={{
        lat: parseFloat(geoBound.Latitude),
        lng: parseFloat(geoBound.Longitude),
      }}
      radius={Number(geoBound.Radius)}
    />
  );
};

export default memo(DisplayCircle);